module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Left-circle-c2d13cce843a5645bc5ee320365091b1.svg";